import React from 'react'
import styled from 'styled-components'

import { palette, fonts, mediaQueries, shadows } from '../../styles/variables'
import { translate } from '../../utils/translation'
import { Text } from '../../components/topography'
import { Line } from '../../components/icon/Icon'

export const Container = styled.div({
  height: '100vh',
  width: '100%',
  overflow: 'auto',
})

export const Content = styled.div((props) => ({
  margin: '0 auto',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  paddingBottom: '20px',
  position: 'relative',
  backgroundColor: palette.white,
  width: props.width || 'auto',
  maxWidth: props.maxWidth || 'inherit',
  [mediaQueries.mobile]: {
    padding: props.mobilePadding || 0,
    margin: '20px 0 120px 0',
    height: 'auto',
    width: props.mobileWidth || props.width || 'auto',
  },
}))

export const Form = styled.form((props) => ({
  display: 'flex',
  width: '500px',
  flexDirection: 'column',
  backgroundColor: palette.white,
  color: palette.darkGray,
  boxShadow: props.showShadow ? shadows.shadowA : 'none',
  flex: 1,
  padding: props.padding || '40px',
  justifyContent: 'flex-start',
  alignItems: props.alignItems || 'normal',
  [mediaQueries.mobile]: {
    fontSize: '12px',
    padding: props.mobilePadding || props.padding || '10px 15px',
    width: '90%',
  },
}))

export const Label = (props) => (
  <Text
    {...props}
    fontSize="14px"
    lineHeight="14px"
    fontFamily={fonts.primaryBook}
    margin="12px 0"
  />
)

export const PrivacySection = styled.div({
  display: 'block',
  margin: '6px 0 24px 0',
  width: '100%',
})

export const InvalidMessage = styled.span({
  left: 0,
  top: 0,
  color: palette.red,
  fontSize: 10,
})

export const CheckBox = ({
  checked,
  onChange,
  children,
  invalid,
  invalidMessageId,
  testid = '',
}) => (
  <>
    <div data-testid={testid}>
      <label className="container">
        <input
          type="checkbox"
          checked={checked}
          onChange={onChange}
          data-testid={testid ? `${testid}-checkbox` : ''}
        />
        <span
          className="checkmark"
          style={{
            left: 0,
            top: 0,
            backgroundColor: invalid ? palette.red : 'auto',
          }}
        />
        {children}
      </label>
    </div>
    {invalid && <InvalidMessage>{translate(invalidMessageId)}</InvalidMessage>}
  </>
)

export const TextOnLine = ({ margin, style, textStyle, text }) => {
  return (
    <div
      style={{
        margin,
        height: '14px',
        position: 'relative',
        width: '100%',
        maxWidth: '500px',
        ...style,
      }}
    >
      <Line
        style={{ padding: 0, margin: 0, position: 'absolute', top: '50%' }}
      />
      <Text
        style={{
          width: 'fit-content',
          padding: '0 12px',
          left: '50%',
          top: '1px',
          background: palette.white,
          transform: 'translateX(-50%)',
          position: 'absolute',
          ...textStyle,
        }}
      >
        {text}
      </Text>
    </div>
  )
}
